import axiosClient from 'http/axios-client';

export const approvalApply = (url, field, value, setShowLoader, theRefetch, allKitsRefetch, setSelected, alertError) => {
  setShowLoader(true);
  axiosClient.put(url, {
    [field]: value,
  })
    .catch((error) => {
      console.error(error.message);
      if (alertError && error.response.data.data.code === 'invitationIsNotAccepted') {
        alertError(error.response.data.message);
      }
    })
    .finally(() => {
      allKitsRefetch();
      theRefetch()
        .then(() => {
          setSelected([]);
          setShowLoader(false);
        });
    });
};
